import { StatePropertyRef } from './ExtendableStore';


export interface EditorModeInfo {
    readonly id: string;
    readonly label: string;
    readonly desc: string;
    readonly icon: string;
}

export const CreateEditorMode = (id: string, label: string, desc: string, icon: string): EditorModeInfo => ({ id, label, desc, icon });
export const EditorModeInfo = StatePropertyRef<EditorModeInfo>('mode', CreateEditorMode('none', '', '', null));
